import { ArrowPathIcon } from '@heroicons/react/24/outline';
import * as Switch from '@radix-ui/react-switch';

import twclsx from 'utils/twclsx';

/**
 * Toggle control for adding and removing products to a user's recurring items list.
 *
 * @param {boolean} [props.checked=false] - Whether the toggle is in the checked (recurring) state
 * @param {Function} [props.onCheckedChange] - Callback fired when the toggle state changes
 */
function RecurringToggle({ checked, onCheckedChange, styles = {} }) {
    return (
        <Switch.Root
            aria-label="Add to Recurring"
            className={twclsx(
                'group relative h-[42px] w-full min-w-60 max-w-[75px] rounded-[42px] bg-off-white',
                styles.root
            )}
            checked={checked}
            onCheckedChange={onCheckedChange}
            onClick={(e) => e.stopPropagation()}
        >
            <Switch.Thumb
                className={twclsx(
                    'absolute left-5 top-1/2 flex aspect-square h-35 -translate-y-1/2 items-center justify-center rounded-full bg-grey-light transition-all duration-200 group-hover:bg-grey-dark data-[state=checked]:left-[calc(100%-40px)] data-[state=checked]:bg-mango group-hover:data-[state=checked]:bg-mango',
                    styles.thumb
                )}
            >
                <ArrowPathIcon className={twclsx('w-[18px] stroke-[2px]', styles.icon)} />
            </Switch.Thumb>
        </Switch.Root>
    );
}

export default RecurringToggle;
